import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const FinTech = () => {
  return <PageTemplate title="FinTech Solutions" subtitle="Financial Technology" breadcrumb="Industries > FinTech"><div className="content-section"><p>Financial technology solutions, digital banking, and payment systems.</p></div></PageTemplate>;
};
export default FinTech; 